<template>
  <div class="container">
    <div class="oferta-container padding-17-left-right">
      <wrap-container class="w100 grid-container grid-container--6-6">
        <wrap-container class="col1 main-title">
          <p id="titulo" class="titulo p28 oscuro hola">
            ¡Hola <span data-obfuscate>{{ nombre }}!</span>
          </p>
          <br />
          <p
            id="subtitulo"
            class="titulo p32 oscuro medium"
            v-safe-html="config.pasos.ofertaCuenta.propuesta"
          />
          <p
            v-if="cuenta"
            id="descripcion"
            v-safe-html="config.pasos.ofertaCuenta.descripcion"
          />
        </wrap-container>
      </wrap-container>
      <wrap-container class="w100 grid-container grid-container--6-6">
        <wrap-container class="cascade col1">
          <div :class="cuenta ? 'oferta empr-cuenta' : 'oferta'">
            <div v-if="!cuenta">
              <div class="card-container">
                <img src="@/assets/img/1x/emprendedores.png" alt="Openpay" />
              </div>
              <p
                class="caja-de-ahorro"
                v-safe-html="config.pasos.ofertaCuenta.titulo"
              />
              <p
                class="subtitulo_cuenta"
                v-safe-html="config.pasos.ofertaCuenta.subtitulo"
              />
            </div>
            <div v-else>
              <p
                class="caja-de-ahorro"
                v-safe-html="config.pasos.ofertaCuenta.tituloConCuenta"
              />
            </div>
            <premios-oferta-caja-ahorro :emprCuenta="cuenta" />
          </div>
          <wrap-container v-if="cuenta" class="empr-cuenta logoop">
            <img
              class="img-consulta"
              src="../assets/img/ofertaNomina/cajaDeAhorro/LogotipoOpenpay_RGB-01 1.svg"
              alt="Logo openpay"
            />
          </wrap-container>
        </wrap-container>
        <wrap-container class="cascade col2">
          <div v-if="!cuenta">
            <div class="qr-container">
              <div class="w-50" data-obfuscate>
                <openmarket-QR
                  class="qr-code"
                  :scale="15"
                  errorCorrectionLevel="L"
                  :url="getURLQR()"
                />
              </div>
              <div class="sms-container w-50">
                <p class="titulo p24 oscuro medium">
                  Escaneá el código QR y seguí desde tu celular
                </p>
                <p class="sms_send">
                  Si no podés escanear el código, te enviamos un SMS para que
                  sigas en tu celular.
                </p>
                <custom-send-sms-link
                  label="Enviar SMS"
                  @click.native="openModalSMS"
                />
              </div>
            </div>
            <offer-group
              class="content-bonus-items margin-bonus-m "
              :label="offerGroupLabel"
            >
              <offer-element
                v-for="inc in beneficios"
                v-bind:key="inc.label"
                :label="inc.label"
                :linktitle="inc.linktitle"
                :linkpath="inc.linkpath"
                label-light="true"
              />
            </offer-group>
            <modal-sms
              :show="showModal"
              @close="showModal = false"
              @sendSMS="sendSMS"
              :buttonLabel="buttonLabel"
              :mensaje="mensajeCuenta"
              quantumObfuscate
            />
          </div>
          <div v-else>
            <div class="card-container card-not-cuenta">
              <img src="@/assets/img/1x/emprendedores.png" alt="Openpay" />
            </div>
          </div>
        </wrap-container>
      </wrap-container>
      <div class="button-mobile" v-if="!cuenta">
        <sales-button
          class="sales-button"
          ref="salesbutton"
          :label="config.pasos.ofertaCuenta.botonSiguiente"
          :color="color"
          @click.native="$router.push(config.pasos.ofertaCuenta.pasoSiguiente)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import OfferGroup from "@/components/core/OfferGroup";
import OfferElement from "@/components/core/OfferElement";
import ModalSms from "@/components/core/modals/ModalSms";
import SalesButton from "@/components/core/SalesButton";
import PremiosOfertaCajaAhorro from "@/components/core/custom/PremiosOfertaCajaAhorro";
import CustomSendSmsLink from "@/components/core/CustomSendSmsLink";
import OpenmarketQR from "../components/core/OpenmarketQR.vue";
import offerPage from "@/mixins/offer-page";

const campania = _BBVA_MOTOR || "ofertaNomina";

export default {
  name: "OfertaEmprendedores",
  mixins: [offerPage],
  components: {
    WrapContainer,
    OfferGroup,
    OfferElement,
    ModalSms,
    SalesButton,
    PremiosOfertaCajaAhorro,
    CustomSendSmsLink,
    OpenmarketQR
  },
  data() {
    return {
      showModal: false,
      buttonLabel: "Enviar SMS",
      color: "#1973B8",
      cuenta: this.$store.getters.getCuenta(),
      innerWidth: window.innerWidth,
      beneficios: require(`@/config/brands/${campania}.js`).beneficios
    };
  },
  computed: {
    nombre() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.nombre) {
        return consulta.nombre;
      }
      return "";
    },
    mensajeCuenta() {
      let mensaje = "Obten&#233; tu Caja de ahorro ahora ingresando a ";
      return mensaje;
    },
    offerGroupLabel() {
      let label = "Hacé crecer tu negocio";
      return this.innerWidth <= 599
        ? label + ":"
        : label + " con BBVA y Openpay:";
    }
  }
};
</script>
<style scoped>
.content-bonus-items {
  margin-left: 17px;
}
.bonus-items {
  margin-top: 50px;
  padding-bottom: 20px;
}
div.container {
  height: 100%;
}
div.container .sales-button {
  display: none;
}

.oferta-container {
  max-width: 1200px;
  margin: 0 auto;
}

div.oferta {
  display: block;
  max-width: 550px;
  margin-bottom: 40px;
}

.empr-cuenta .caja-de-ahorro {
  font-size: 20px;
  text-align: center;
}

.empr-cuenta {
  padding: 20px;
}

p {
  margin-top: 0px;
  margin-bottom: 0px;
}

p#subtitulo {
  margin-bottom: 37px;
}

.main-title {
  margin-bottom: -20px;
}

.caja-de-ahorro {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 26px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #666666;
  margin-top: 40px;
  margin-bottom: 16px;
}

.subtitulo_cuenta {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  color: #666666;
  margin-bottom: 50px;
}

.middle-iwt {
  margin-left: 62px;
  margin-right: 62px;
}

.button-mobile {
  display: none;
}

.qr-container {
  display: grid;
  grid-gap: 5px;
  padding-bottom: 10%;
}
.sms-container {
  margin-top: 5px;
  grid-column: 2;
  align-self: top;
}
.sms_send {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  padding-bottom: 5%;
}
.logoop {
  display: none;
}
@media screen and (max-width: 599px) {
  #titulo {
    font-size: 16px;
  }
  #subtitulo {
    font-size: 22px;
  }
  .caja-de-ahorro {
    align-items: normal;
    line-height: 1.2;
    font-size: 20px;
    margin-top: 30px;
  }
  .subtitulo_cuenta {
    text-align: center;
    font-size: 15px;
    margin-bottom: 40px;
  }
  .middle-iwt {
    margin-left: 0px;
    margin-right: 0px;
  }
  .card-container {
    margin: 0 auto;
    text-align: center;
  }
  .card {
    min-width: 149px;
    min-height: 94px;
  }
  .margin-benefits-m {
    margin-top: 32px;
  }

  .button-mobile {
    display: block;
    margin-bottom: 60px;
    margin-top: -25px;
  }

  div.container .sales-button {
    display: inline-block;
  }
  .qr-container {
    display: none;
  }
  .card-not-cuenta {
    display: none;
  }
  .oferta.empr-cuenta {
    background: #e6e6e6;
  }
  .img-consulta {
    height: 10vh;
  }
  .logoop {
    display: flex;
    justify-content: center;
  }
}
@media screen and (min-width: 601px) and (max-width: 1024px) {
  .card-container {
    margin: 0 auto;
    text-align: center;
  }
  .hola {
    width: 200%;
  }
  .tenemos {
    width: 200%;
    text-align: center;
  }
  .caja-de-ahorro {
    text-align: center;
  }
  .subtitulo_cuenta {
    text-align: center;
  }
  .middle-iwt {
    margin-left: 0px;
    margin-right: 0px;
  }
}
</style>
